import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  CreateLeadWorkflowMutation,
  CreateLeadWorkflowMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const CREATE_LEAD_WORKFLOW_MUTATION = graphql(`
  mutation createLeadWorkflow(
    $createWorkflow: CreateWorkflow!
    $stageFilterRequest: WorkflowStageSearchRequest
  ) {
    createLeadWorkflow(createNewWorkflow: $createWorkflow) {
      id
      isDefault
      transitions {
        id
        group
        order
        stage {
          id
          name
          color
          iconColor
          iconName
          leadCount(WorkflowStageSearchRequest: $stageFilterRequest)
        }
      }
    }
  }
`);

export function useCreateLeadWorkflow(
  options?: UseMutationOptions<
    CreateLeadWorkflowMutation,
    unknown,
    CreateLeadWorkflowMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const mutation = useGraphQlMutation(CREATE_LEAD_WORKFLOW_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: ["leadWorkflow"] });
      await queryClient.invalidateQueries({ queryKey: ["leads"] });

      options?.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context);
    },
  });

  return mutation;
}
